<template>
  <el-menu router
           :default-active="$route.path"
           :collapse-transition="false"
           background-color="#272727"
           text-color="#939393"
           class="el-menu-vertical-demo">
    <el-submenu index="1">
      <template slot="title">
        <i class="iconfont">&#xe641;</i>
        <span>栏目管理</span>
      </template>
      <el-menu-item index="/website/ColumnDetail">栏目编辑</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  name: 'website-nav',
};
</script>
<style lang="less" scoped>
.el-submenu .el-menu-item {
  padding: 0;
  min-width: 150px;
}
</style>




// WEBPACK FOOTER //
// src/components/columnConfig/columnNav.vue